<template>

  <div class="active-basic">
    <div class="common-form">基本信息</div>

    
    <el-form-item label="选择用户">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
            <div>{{ user_info.nickName }}</div>
          </div>
          <div>
            <el-link :underline="false" disabled>选择后不可更改</el-link>
          </div>
        </el-row>
      </el-form-item>

    
    <el-form-item label="备注" prop="title" >
      <el-input v-model="form.remark" placeholder="请输入备注" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="佣金类型">
      <template >
        <el-radio-group v-model="form.log_type">
          <el-radio :label="22">房源推荐佣金</el-radio>
          <el-radio :label="23">房源成交佣金</el-radio>
        </el-radio-group>
      </template>

    </el-form-item>

    
    <el-form-item label="实际金额" prop="act_price" >
      <el-input type="text"  v-model="form.act_price" placeholder="请输入实际金额" class="max-w460"></el-input>
    </el-form-item>



    <el-form-item label="返佣金额" prop="price" >
      <el-input type="text"  v-model="form.price" placeholder="请输入返佣金额" class="max-w460"></el-input>
    </el-form-item>


  
    <el-form-item label="是否结算">
      <template >
        <el-radio-group v-model="form.is_settled">
          <el-radio :label="0">未结算</el-radio>
          <el-radio :label="1">已结算</el-radio>
        </el-radio-group>
      </template>

    </el-form-item>

      <!--添加-->
      <GetUser :is_open="open_add" :multi="multi" @close="closeDialogFunc_user"></GetUser>
  </div>
</template>

<script>

import Uediter from '@/components/UE1.vue';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import GetUser from '@/components/user/GetUser.vue';
import { create } from 'lodash';
export default {
  components: {
    Uediter,
    Categoryas,
    Upload,
    GetUser
  },
  data() {
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传房源图'));
      } else {
        callback();
      }
    };
    return {
      /*如果没有后面的-8.64e7就是不可以选择今天的*/
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      isupload:false,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传房源广告图片', trigger: 'change' }],
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        },
      },
      ueditor2: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ueditor3: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ueditor4: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ue1:"ue1",
      ue2:"ue2",
      ue3:"ue3",
      ue4:"ue4",
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      isVideoUpload: false,
      cindex:0,
      open_add:false,
      user_info:{},
      multi:false

    };
  },
  props: ['form','editType'],
  mounted(){
    if(this.form.user){
      this.user_info = this.form.user
    }
  },
  methods: {
        

      /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc_user(e) {
        console.log("e",e)
        if (e.type != 'error') {
          this.user_info = e.params;
          this.form.user_id = e.params.user_id;
        }
        this.open_add = false;
      },
   /* 打开视频 */
   openVideoUpload() {
      this.isVideoUpload = true;
    },
    /* 获取视频 */
    returnVideosFunc(e) {
      console.log(e);
      if (e != null && e.length > 0) {
        this.form.video = e[0].file_path;
      }
      this.isVideoUpload = false;
    },


    /*打开上传图片*/
    openProductUpload: function () {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.imgUrl.concat(e);
        this.$set(this.form, "imgUrl", imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.imgUrl.splice(index, 1);
    },

    addLabel(code=""){
  
      this.form.label.push({
        index:  this.form.label.length+1,
        name:""
      });
    
    },
    delLabel(e,index){//删除广告
      this.form.label.splice(index, 1);
    },


    del(id){
      var arr = [];
      console.log(id)
      this.form.time_bucket.forEach(function(res){
        if(res.id != id){
          arr.push(res)
        }
      })
      this.form.time_bucket = arr
    },
    add(){
      console.log(this.form)
      this.form.time_bucket.push({
        id:  (Math.floor(Math.random() * 99999) + 1)+"_"+ (Math.floor(Math.random() * 1000) + 1)+"_"+ (Math.floor(Math.random() * 10) + 1),
        start_time:"",
        end_time:"",
      });
      console.log('this.form.time_bucket',this.form.time_bucket);
    },
    chooseCategory(index){
      this.cindex = index;
      this.iscategorya = true;
    },
     /*获取富文本内容*/
    contentChangeFunc(e){
      this.form.content=e;
    },
    contentChangeFuncSubtitle(e){
      this.form.subtitle = e;
    },
    contentChangeFuncRoute(e){
      this.form.route = e;
    },
    contentChangeFuncNotice(e){
      this.form.notice = e;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.imgUrl = e[0].file_path;

      }
      this.isupload = false;
    },
    addCate(code=""){
  
  this.form.categorya.push({
    index:  this.form.categorya.length+1,
    name:""
  });

},
delCate(e,index){//删除广告
  this.form.categorya.splice(index, 1);
},
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.iscategorya = false;
      if (e.type === 'success') {
        self.form.categorya[e.index] = {
            name: e.params[0].name,
            categorya_id: e.params[0].categorya_id,
            image: e.params[0].image,
          }
      }
    },
  

  }
};
</script>

<style lang="scss">
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/log/part/Basic.vue